(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }
  document.addEventListener('DOMContentLoaded', () => {
    const facets = document.querySelector('.facets.facets--horizontal');
    const banner = document.querySelector('.collection_page .collection-page-banner');

    if (!facets || !banner) return;

    const syncStickyFacetsState = () => {
      const hasProducts = Boolean(document.querySelector('#ResultsList .product-grid__item'));
      if (!hasProducts) {
        facets.classList.remove('is-sticky-active');
        return;
      }

      const rect = banner.getBoundingClientRect();
      const bannerHeight = banner.offsetHeight;
      if (!bannerHeight) return;

      const scrolled = Math.min(Math.max(-rect.top, 0), bannerHeight);
      const scrollProgress = scrolled / bannerHeight;

      facets.classList.toggle('is-sticky-active', scrollProgress >= 0.8);
    };

    window.addEventListener('scroll', syncStickyFacetsState, { passive: true });
    window.addEventListener('resize', syncStickyFacetsState);
    syncStickyFacetsState();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-results"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    if (!document.body.classList.contains('search_page')) return;

    const facets = document.querySelector('.search_page .facets.facets--horizontal');
    const searchInput = document.querySelector('.search_page .search-page-input__parent');

    if (!facets || !searchInput) return;

    const syncStickyFacetsState = () => {
      const rect = searchInput.getBoundingClientRect();
      const triggerHeight = searchInput.offsetHeight;
      const headerHeight = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height')) || 0;

      if (!triggerHeight) return;

      const scrolled = Math.min(Math.max(headerHeight - rect.top, 0), triggerHeight);
      const scrollProgress = scrolled / triggerHeight;

      facets.classList.toggle('is-sticky-active', scrollProgress >= 0.8);
    };

    window.addEventListener('scroll', syncStickyFacetsState, { passive: true });
    window.addEventListener('resize', syncStickyFacetsState);
    syncStickyFacetsState();
  });

  } catch(e) { console.error(e); }
})();
})();
